'use strict';

const Backbone = require('backbone');
const i18n = require('i18next');

class Container extends Backbone.Model {
    get defaults() {
        return {
            name: '',
            isRoot: false,
            isSystem: false,
            kind: 'container',
            parent: null
        };
    }

    getSystemName() {
        if (this.isSystem()) {
            return this.get('name');
        }
    }

    getName() {
        const name = this.get('name');
        if (this.isSystem()) {
            return i18n.t(`data:systemContainer.${name}.name`);
        } else {
            return name;
        }
    }

    isRoot() {
        return this.get('isRoot');
    }

    isSystem() {
        return this.get('isSystem');
    }
}

module.exports = Container;



// WEBPACK FOOTER //
// ./data/domain/entity/container.js